export default function hideFloatingREToolbar(el?: HTMLElement | null): boolean {
    if (!el) return false;
    if (el.style.opacity === '0') return false;

    el.classList.add('rich-editor-toolbar__hidden');
    el.style.opacity = '0';
    el.style.top = '';
    el.style.left = '';

    return true;
}

// #region Tests

if (import.meta.vitest) {
    const { describe, it, expect } = import.meta.vitest;
    describe('hideFloatingREToolbar', async () => {
        it('hides toolbar', () => {
            const el = document.createElement('div');
            el.style.opacity = '1';
            el.style.top = '0';
            el.style.left = '0';
            expect(hideFloatingREToolbar(el)).toBe(true);
            expect(el.style.opacity).toBe('0');
            expect(el.style.top).toBe('');
            expect(el.style.left).toBe('');
        });

        it('does not modify the element if it is already hidden', () => {
            const el = document.createElement('div');
            el.style.opacity = '0';
            el.style.top = '0';
            el.style.left = '0';
            expect(hideFloatingREToolbar(el)).toBe(false);
            expect(el.style.opacity).toBe('0');
            expect(el.style.top).toBe('0px');
            expect(el.style.left).toBe('0px');
        });
    });
}

// #endregion
